import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaChevronLeft } from "react-icons/fa";
import "./provider.css";
import swal from "sweetalert";
import DOMPurify from "dompurify";
import {
  australiaCampus,
  canadaCampus,
  countries_code,
  franceCampus,
  germanyCampus,
  newZealandCampus,
  pakistanCampus,
  southKoreaCampus,
  chinaCampus,
  uaeCampus,
  ukCampus,
  usaCampus,
  CyprusNorth,
  FinlandCampus,
  TurkeyCampus,
  NetherlandsCampus,
  SpainCampus,
  IrelandCampus,
  malaysiaCampus,
} from "../../utilis/constants";
import { post_ApiManager, get_ApiManager } from "../ApiManager/ApiManager";
import ProviderFormMultiselect from "./ProviderFormMultiselect";
import { getProviderFormLayout } from "./providerFormLayout";
import ProviderFormSkeleton from "./ProviderFormSkeleton";
import {
  applyProviderDescriptionToPayload,
  extractProviderApiErrorMessage,
  resolveProviderDescriptionForSave,
} from "./providerFormHelpers";
import "../../styles/tailwind.css";

const EditProvider = ({
  embedded = false,
  formId,
  providerId: providerIdProp,
  onSuccess,
  onCancel,
  onSavingChange,
}) => {
  const titleRef = useRef();
  const history = useNavigate();
  const location = useLocation();
  const { providerid: routeProviderId } = useParams();
  const providerid = providerIdProp || routeProviderId;
  const returnTo =
    location.state?.returnTo || "/providers/view-providers";
  const backLabel = returnTo.includes("provider-details")
    ? "Back to Provider"
    : "Back to Providers";
  const [nameError, setNameError] = useState("");
  const [campusError, setCampusError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [input, setInput] = useState("");
  const [tags, setTags] = useState([]);
  const [endDateError, setEndDateError] = useState("");
  const [selectedCampus, setSelectedCampus] = useState([]);
  const [categories, setCategories] = useState([]);
  const [personDetail, setPersonDetail] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [details, setDetails] = useState([]);
  const [campus, setCampus] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [personList, setPersonList] = useState([
    { name: "", mobile: "", landline: "", designation: "" },
  ]);
  const [detailLoaded, setDetailLoaded] = useState(!providerid);

  useEffect(() => {
    if (!embedded) {
      document.title = "Edit Provider";
    }
    getCategory();
  }, [embedded]);

  useEffect(() => {
    if (providerid) {
      setDetailLoaded(false);
      getDetail();
    }
  }, [providerid]);

  const getCategory = async () => {
    let url = "provider-categories";
    let data = "";
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("Provider Categories", res);
        const list = Array.isArray(res.data?.data) ? res.data.data : [];
        setCategories(list);
      },
      (err) => {
        console.log(err);
      },
    );
  };

  const getDetail = async () => {
    setDetailLoaded(false);
    let url = "getProviderDetail";
    let data = providerid;
    get_ApiManager(
      data,
      url,
      (res) => {
        console.log("provider detail", res);
        setDetails(res.data.data["detail"]);
        const savedCategoryId = res.data.data["detail"]?.["categoryid"];
        if (savedCategoryId !== undefined && savedCategoryId !== null) {
          setCategory(String(savedCategoryId));
        }

        setPersonDetail(res.data.data["persondetail"]);
        if (res.data.data["persondetail"].length) {
          setPersonList(res.data.data["persondetail"]);
        }
        const string = res.data.data["detail"]["city"];
        const usingSplit = string.split(",");
        let options = usingSplit.map(function (intake) {
          return { value: intake, label: intake };
        });
        setTags(options);
        console.log(options);
        setValue(res.data.data["detail"]["country"]);
        setAddress(String(res.data.data["detail"]?.address || "").trim());
        setDetailLoaded(true);
      },
      (err) => {
        console.log(err);
        setDetailLoaded(true);
      },
    );
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...personList];
    list[index][name] = value;
    setPersonList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...personList];
    list.splice(index, 1);
    setPersonList(list);
  };

  const handleAddClick = () => {
    setPersonList([
      ...personList,
      { name: "", mobile: "", landline: "", designation: "" },
    ]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    console.log(tags);

    setStartDateError("");
    setEndDateError("");
    setCountryError("");
    setCategoryError("");

    let Name,
      Campus,
      Country,
      Category,
      Startdate,
      Enddate,
      Designation;
    if (!name) {
      Name = details["name"];
    } else {
      Name = name;
    }

    if (tags.length <= 0) {
      setCampusError("Please enter campus");
      window.scrollTo(0, titleRef);
    }

    if (!country) {
      if (!details["country"]) {
        setCountryError("Please select country");
        window.scrollTo(0, titleRef);
        return false;
      } else {
        Country = details["country"];
      }
    } else {
      Country = country;
    }

    if (!category) {
      if (!details["categoryid"]) {
        setCategoryError("please select category");
        window.scrollTo(0, titleRef);
        return false;
      } else {
        Category = details["categoryid"];
      }
    } else {
      Category = category;
    }

    if (!startdate) {
      if (!details["agreementstartdate"]) {
        setStartDateError("Please enter start date");
        return false;
      } else {
        Startdate = details["agreementstartdate"];
      }
    } else {
      Startdate = startdate;
    }

    if (!enddate) {
      if (!details["agreementenddate"]) {
        setEndDateError("Please enter end date");
        return false;
      } else {
        Enddate = details["agreementenddate"];
      }
    } else {
      Enddate = enddate;
    }

    if (!selectedOption) {
      Designation = details["designation"];
    } else {
      Designation = selectedOption;
    }
    let array2 = [];
    array2 = selectedCampus.map((object) => object.value);
    var newArray = array2.toString();

    const descriptionValue = resolveProviderDescriptionForSave({
      newDescription: description,
    });

    const data = applyProviderDescriptionToPayload(
      {
        name: Name,
        city: newArray ? newArray : details["city"],
        country: Country,
        address: String(address || details["address"] || "").trim(),
        categoryid: Category,
        agreement_startdate: Startdate,
        agreement_enddate: Enddate,
        person_contact_list: personList,
        designation: Designation,
      },
      descriptionValue,
    );
    console.log(data);
    let url = `updateProvider/${providerid}`;
    onSavingChange?.(true);
    post_ApiManager(
      data,
      url,
      (res) => {
        onSavingChange?.(false);
        console.log("Edited Provider", res);
        if (res.data.error) {
          swal(" ", res.data.error, "error");
        } else {
          swal("Success!", res.data.message, "success");
          if (embedded && onSuccess) {
            onSuccess();
          } else {
            history(returnTo);
          }
        }
      },
      (err) => {
        onSavingChange?.(false);
        console.log(err);
        swal(
          " ",
          extractProviderApiErrorMessage(err, "Failed to update provider."),
          "error",
        );
      },
    );
  };

  const onTagChange = (e) => {
    const { value } = e.target;
    setInput(value);
  };

  const setValue = (value) => {
    if (value == "Australia") {
      let options = australiaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Pakistan") {
      let options = pakistanCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value === "Korea South") {
      let options = southKoreaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value === "China") {
      let options = chinaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "UK") {
      let options = ukCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Canada") {
      let options = canadaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "New Zealand") {
      let options = newZealandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Germany") {
      let options = germanyCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "USA") {
      let options = usaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "France") {
      let options = franceCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Cyprus North") {
      let options = CyprusNorth.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "United Arab Emirates") {
      let options = uaeCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Finland") {
      let options = FinlandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Netherlands") {
      let options = NetherlandsCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Turkey") {
      let options = TurkeyCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Spain") {
      let options = SpainCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Ireland") {
      let options = IrelandCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    } else if (value == "Malaysia") {
      let options = malaysiaCampus.map(function (intake) {
        return { value: intake.title, label: intake.title };
      });
      setCampus(options);
    }
    setCountry(value);
  };

  const onCampusSelect = (selectedList) => {
    setSelectedCampus(selectedList);
  };
  const onCampusRemove = (selectedList) => {
    setSelectedCampus(selectedList);
  };

  const handleCancel = () => {
    if (embedded && onCancel) {
      onCancel();
      return;
    }
    history(returnTo);
  };

  const ui = getProviderFormLayout(embedded);

  if (providerid && !detailLoaded) {
    return (
      <div className={ui.wrap}>
        {!embedded && (
          <button
            type="button"
            onClick={handleCancel}
            className={ui.backBtn}
          >
            <FaChevronLeft size={10} />
            {backLabel}
          </button>
        )}

        <div className={ui.inner}>
          {!embedded && (
            <div className={ui.cardHeader}>
              <h1 className={ui.cardTitle}>Edit Provider</h1>
            </div>
          )}
          <ProviderFormSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className={ui.wrap}>
      {!embedded && (
        <button
          type="button"
          onClick={handleCancel}
          className={ui.backBtn}
        >
          <FaChevronLeft size={10} />
          {backLabel}
        </button>
      )}

      <div className={ui.inner}>
        {!embedded && (
          <div className={ui.cardHeader}>
            <h1 className={ui.cardTitle}>Edit Provider</h1>
          </div>
        )}

        <form
          id={formId}
          ref={titleRef}
          className={ui.form}
          onSubmit={onSubmit}
        >
          <div className={ui.section}>
            <div
              className={ui.gridClass}
              {...(ui.gridStyle ? { style: ui.gridStyle } : {})}
            >
              <div className={ui.field}>
                <label className={ui.label}>
                  Provider Name <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.control}>
                  <input
                    type="text"
                    defaultValue={details["name"]}
                    onChange={(e) => setName(e.target.value)}
                    className={ui.input}
                    placeholder="Please Enter"
                  />
                </div>
                {nameError && (
                  <small className={ui.error}>{nameError}</small>
                )}
              </div>

              <div className={ui.field}>
                <label className={ui.label}>
                  Category <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.control}>
                  <select
                    className={ui.select}
                    value={category ? String(category) : ""}
                    onChange={(e) => setCategory(e.target.value)}
                    aria-label="Category"
                  >
                    <option value="">Please Select</option>
                    {[]
                      .concat(categories)
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((value, index) => (
                        <option key={index} value={String(value.id)}>
                          {value.name}
                        </option>
                      ))}
                  </select>
                </div>
                {categoryError && (
                  <small className={ui.error}>
                    {categoryError}
                  </small>
                )}
              </div>

              <div className={ui.field}>
                <label className={ui.label}>
                  Country <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.control}>
                  <select
                    className={ui.select}
                    value={country || details["country"] || ""}
                    onChange={(e) => setValue(e.target.value)}
                    aria-label="Country"
                    name="country"
                  >
                    <option value="">Please Select</option>
                    {countries_code.map((value) => (
                      <option key={value.country} value={value.value}>
                        {value.value}
                      </option>
                    ))}
                  </select>
                </div>
                {countryError && (
                  <small className={ui.error}>
                    {countryError}
                  </small>
                )}
              </div>

              <div className={ui.field}>
                <label className={ui.label}>
                  Campus <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.controlMulti}>
                  <ProviderFormMultiselect
                    options={[]
                      .concat(campus)
                      .sort((a, b) => (a.label > b.label ? 1 : -1))}
                    placeholder="Please Select"
                    displayValue="label"
                    selectedValues={tags}
                    onSelect={onCampusSelect}
                    onRemove={onCampusRemove}
                    className={embedded ? "w-full" : ""}
                  />
                </div>
                {campusError && (
                  <small className={ui.error}>
                    {campusError}
                  </small>
                )}
              </div>

              <div className={ui.fieldFull}>
                <label className={ui.label}>Address</label>
                <div className={ui.control}>
                  <textarea
                    className={ui.textarea}
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Enter complete provider address"
                    rows={3}
                    aria-label="Address"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={ui.section}>
            <h3 className={ui.sectionTitle}>
              Contact Person(s)
            </h3>

            {personList.map((x, i) => (
              <div key={i} className={ui.contactBlock}>
                <div
                  className={ui.contactGridClass}
                  {...(ui.contactGridStyle ? { style: ui.contactGridStyle } : {})}
                >
                  <div className={ui.field}>
                    <label className={ui.label}>
                      Person Name
                    </label>
                    <div className={ui.control}>
                      <input
                        type="text"
                        name="name"
                        defaultValue={x.name && x.name}
                        onChange={(e) => handleInputChange(e, i)}
                        className={ui.input}
                        placeholder="Please Enter"
                      />
                    </div>
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>
                      Person Email
                    </label>
                    <div className={ui.control}>
                      <input
                        type="email"
                        name="email"
                        defaultValue={x.email && x.email}
                        onChange={(e) => handleInputChange(e, i)}
                        className={ui.input}
                        placeholder="Please Enter"
                      />
                    </div>
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>
                      Designation
                    </label>
                    <div className={ui.control}>
                      <select
                        className={ui.select}
                        name="designation"
                        defaultValue={x.designation || ""}
                        onChange={(e) => handleInputChange(e, i)}
                      >
                        <option value="">
                          {x.designation ? x.designation : "Please Select"}
                        </option>
                        <option value="Accounts Manager">
                          Accounts Manager
                        </option>
                        <option value="Admissions Manager">
                          Admissions Manager
                        </option>
                        <option value="Marketing Manager">
                          Marketing Manager
                        </option>
                        <option value="Owner/Director">Owner/Director</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>Mobile</label>
                    <div className={ui.control}>
                      <input
                        type="tel"
                        inputMode="tel"
                        autoComplete="tel"
                        name="mobile"
                        defaultValue={x.mobile && x.mobile}
                        onChange={(e) => handleInputChange(e, i)}
                        className={ui.input}
                        placeholder="Please Enter"
                      />
                    </div>
                  </div>

                  <div className={ui.field}>
                    <label className={ui.label}>Landline</label>
                    <div className={ui.control}>
                      <input
                        type="tel"
                        inputMode="tel"
                        autoComplete="tel"
                        name="landline"
                        defaultValue={x.landline && x.landline}
                        onChange={(e) => handleInputChange(e, i)}
                        className={ui.input}
                        placeholder="Please Enter"
                      />
                    </div>
                  </div>
                </div>

                <div className={ui.contactActions}>
                  {personList.length !== 1 && (
                    <button
                      type="button"
                      className={ui.btnOutlineDanger}
                      onClick={() => handleRemoveClick(i)}
                    >
                      Remove
                    </button>
                  )}
                  {personList.length - 1 === i && (
                    <button
                      type="button"
                      className={ui.btnFill}
                      onClick={() => handleAddClick()}
                    >
                      Add More
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className={ui.section}>
            <h3 className={ui.sectionTitle}>
              Contract Information
            </h3>

            <div
              className={ui.gridClass}
              {...(ui.gridStyle ? { style: ui.gridStyle } : {})}
            >
              <div className={ui.field}>
                <label className={ui.label}>
                  Agreement Start Date <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.control}>
                  <input
                    type="date"
                    onChange={(e) => setStartDate(e.target.value)}
                    defaultValue={details["agreementstartdate"]}
                    className={ui.input}
                  />
                </div>
                {startDateError && (
                  <small className={ui.error}>
                    {startDateError}
                  </small>
                )}
              </div>

              <div className={ui.field}>
                <label className={ui.label}>
                  Agreement End Date <span className={ui.requiredMark}>*</span>
                </label>
                <div className={ui.control}>
                  <input
                    type="date"
                    onChange={(e) => setEndDate(e.target.value)}
                    defaultValue={details["agreementenddate"]}
                    className={ui.input}
                  />
                </div>
                {endDateError && (
                  <small className={ui.error}>
                    {endDateError}
                  </small>
                )}
              </div>

              <div className={ui.fieldSpan2}>
                <label className={ui.label}>New Note (optional)</label>
                <div className={ui.control}>
                  <textarea
                    className={ui.textarea}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Optional"
                    name="description"
                    rows="3"
                  />
                </div>
                {details["note"] && (
                  <div
                    className={ui.existingNote}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(details["note"]),
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          {!embedded && (
            <div className={ui.footer}>
              <button
                type="button"
                onClick={handleCancel}
                className={ui.cancelBtn}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={ui.submitBtn}
              >
                Update Provider
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default EditProvider;
